import { getToken } from 'firebase/messaging';
import { initMessaging } from './firebase';
import env from '@/config/env';

const vapidKey = env.FIREBASE_VAPID_KEY;

export default async function getFcmTokenWithPermissionCheck() {
  try {
    const permission = Notification.permission;
    const messagingInstance = await initMessaging();

    if (!messagingInstance) {
      throw new Error('FIREBASE_MESSAGING_NOT_SUPPORTED');
    }

    if (permission === 'granted') {
      const token = await getToken(messagingInstance, {
        vapidKey,
      });

      return {
        token,
        permission,
      };
    } else {
      return {
        token: null,
        permission,
      };
    }
  } catch (error) {
    throw error;
  }
}
